import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedSeccionits,
  addingSeccionits,
  addingSeccionitsFailed,
  editedSeccionits,
  editingSeccionits,
  editingSeccionitsFailed,
  foundSeccionits,
  loadedSeccionits,
  loadingSeccionits,
  loadingSeccionitsFailed,
  removedSeccionit,
  removingSeccionit,
  removingSeccionitFailed,
  searchingSeccionits,
  searchingSeccionitsFailed,
  SeccionitsAction,
  SeccionitsActionTypes,
  softRemovedSeccionits,
  softRemovingSeccionits,
  softRemovingSeccionitsFailed,
} from '../actions/seccionitsActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchSeccionitsEpic: Epic<SeccionitsAction, SeccionitsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionitsActionTypes.SEARCH_SECCIONITS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/seccionits/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundSeccionits(response.data, action.keep)),
        startWith(searchingSeccionits()),
        catchError(() => of(searchingSeccionitsFailed()))
      )
    })
  )

const loadSeccionitsEpic: Epic<SeccionitsAction, SeccionitsAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(SeccionitsActionTypes.LOAD_SECCIONITS)),
    switchMap((action) => {
      let url = `${API_URL}/api/seccionits/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedSeccionits(response.data)),
        startWith(loadingSeccionits()),
        catchError(() => of(loadingSeccionitsFailed()))
      )
    })
  )
}

const addSeccionitsEpic: Epic<SeccionitsAction, SeccionitsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionitsActionTypes.ADD_SECCIONITS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/seccionits/`, data, config)).pipe(
        map((response) => addedSeccionits(response.data)),
        startWith(addingSeccionits()),
        catchError((err) => of(addingSeccionitsFailed(err.response)))
      )
    })
  )

const removeSeccionitsEpic: Epic<SeccionitsAction, SeccionitsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionitsActionTypes.REMOVE_SECCIONIT)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionits/${action.payload._id}`)).pipe(
        map((response) => removedSeccionit()),
        startWith(removingSeccionit()),
        catchError(() => of(removingSeccionitFailed()))
      )
    )
  )

const softRemoveSeccionitsEpic: Epic<SeccionitsAction, SeccionitsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionitsActionTypes.SOFT_REMOVE_SECCIONITS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionits/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedSeccionits(response.data.record)),
        startWith(softRemovingSeccionits()),
        catchError((err) => of(softRemovingSeccionitsFailed(err.response)))
      )
    )
  )

const editSeccionitsEpic: Epic<SeccionitsAction, SeccionitsAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionitsActionTypes.EDIT_SECCIONITS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/seccionits/${action.payload._id}`, data, config)).pipe(
        map((response) => editedSeccionits(response.data)),
        startWith(editingSeccionits()),
        catchError((err) => of(editingSeccionitsFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchSeccionitsEpic,
  loadSeccionitsEpic,
  addSeccionitsEpic,
  removeSeccionitsEpic,
  softRemoveSeccionitsEpic,
  editSeccionitsEpic
)
